import { makeStyles } from "@material-ui/core/styles";

// D8.25.1 — Estilos.
export const useStyles = makeStyles((theme) => ({
  // Mismo lenguaje que Informes: borde fino en vez de sombra (doc 0447, D6c).
  tableContainer: {
    marginTop: theme.spacing(2),
    borderRadius: 12,
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: "none"
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(2)
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 200
  },
  errorContainer: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.error.main
  },
  sizeCell: {
    fontWeight: 600
  },
  actionCell: {
    width: 120
  }
}));
